import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.368.454 11 9.085l8.133-8.13a1 1 0 0 1 1.414 1.413L12.414 10.5l7.632 7.633a1 1 0 0 1-1.414 1.414l-7.633-7.632-8.13 8.132a1 1 0 0 1-1.415-1.414L9.585 10.5.955 1.87A1 1 0 0 1 2.367.453Z"
    }, null, -1)
  ]))]))
}
export default { render: render }